<template>
  <div class="task-list" @click="openNotice">
    <el-tooltip content="导入导出管理" placement="bottom" effect="light" popper-class="tooltip-import">
      <el-badge :hidden="doingTaskCount <= 0" :max="99" :value="doingTaskCount" class="item">
        <i class="iconfont icon-daorudaochu"></i>
      </el-badge>
    </el-tooltip>
  </div>
</template>
<script>
import { mapState } from "vuex"
import { _bus } from "@/utils/index"

export default {
  name: "ImportExportModule",
  data() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapState("user", ["doingTaskCount"])
  },

  mounted() {
    _bus.$on("openExportDodule", this.openNotice)

    // 获取是否有未读
    this.getTaskCount()
  },
  methods: {
    openNotice() {
      // 打开列表
      this.$ImportExportPage.show()
    },

    getTaskCount() {
      // 获取是否有未读
      this.$store.dispatch("user/getCurrentTask")
    }
  }
}
</script>

<style scoped lang="scss">
.msg {
  color: #999;
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .badge {
    position: absolute;
    right: 3px;
    top: -5px;
  }

  .icon-xiaoxi {
    margin: 0 auto;
    color: #ffffff;
  }
}
</style>
<style>
.task-list {
  text-align: center;
  cursor: pointer;
}
</style>
